import React from "react";
import { IModule } from "../types";
import { ArticlePanel, IArticlePanelProps } from "../../../components/panels/ArticlePanel";

export type GetArticlePanelProps = IModule<IArticlePanelProps>;

export const getArticlePanel = (props: GetArticlePanelProps) => {
  const {
    id, title, image, content, showCtaCard,
  } = props;

  return (
    <ArticlePanel
      key={id}
      title={title}
      image={image}
      content={content}
      showCtaCard={showCtaCard}
    />
  );
};
